import { render, staticRenderFns } from "./modal_person_edit_form.vue?vue&type=template&id=457291f6&scoped=true"
import script from "./modal_person_edit_form.vue?vue&type=script&lang=js"
export * from "./modal_person_edit_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457291f6",
  null
  
)

export default component.exports